import React, {useEffect, useState, useRef} from 'react'
import Button from 'react-bootstrap-latest/Button';
import Modal from 'react-bootstrap-latest/Modal';
import {Swiper, SwiperSlide} from 'swiper/react';
import classnames from 'classnames';
import Classes from '../../../../common/Classes';
import {Navigation} from 'swiper/modules';
import ProductImageInOverLay from './ProductImageInOverLay';
import '../../../../../styles/premium-exhibitor-modal.less';
import PropTypes from 'prop-types';
import dtmTags from '../../../../common/dtmTags';
import {ItemType, ImageTypes, Packages} from '../../../../common/Constants';
import StringFormatter from '../../../../common/StringFormatter';
import RenderPdf from './RenderPdf';
import Utils from '../../../../common/Utils';
import {faChevronLeft, faChevronRight, faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {trackMixpanelEvent} from '../../../../common/MixpanelHelper';
import mixpanelConstants from '../../../../common/mixpanelConstants';
import ProductVideoInOverLay from './ProductVideoInOverLay';

const ExhibitorModal = (props) => {
    const {showModal, closeModal, products, clickedSlideIndex, setClickedSlideIndex, translations, navigation,
      exhibitingOrganisation, documents, type, isVidyardReadyProp } = props;
    const [viewedDocuments, setViewedDocuments] = useState(new Set([clickedSlideIndex]));
    const [isVidyardReady, setIsVidyardReady] = useState(isVidyardReadyProp);
    const [displayError, setDisplayError] = useState(false);
    const [previousIndex, setPreviousIndex] = useState(null);
    let exhibitorDetailsPageLink;
    let productDetailsPageLink;
    const environment = Utils.getCurrentEnvironment();
    if (!Utils.isDevEnvironment(environment) && !Utils.isShowEnvironment(environment)) {
        if (exhibitingOrganisation.name) {
            let exhibitorName = Utils.getSEOFriendlyName(exhibitingOrganisation.name);
            exhibitorDetailsPageLink = StringFormatter.format(navigation.exhibitorPublicDetailsUrlFormat, exhibitorName.concat('.', exhibitingOrganisation.organisationGuid));
        }
        if (type === ItemType.Product && products[clickedSlideIndex].name) {
            let productName = Utils.getSEOFriendlyName(products[clickedSlideIndex].name);
            productDetailsPageLink = StringFormatter.format(navigation.productDetailsUrlFormat,
                exhibitingOrganisation.id.concat('.', productName), products[clickedSlideIndex].id);
        }
      } else {
        exhibitorDetailsPageLink = StringFormatter.format(navigation.exhibitorPublicDetailsUrlFormat, exhibitingOrganisation.organisationGuid);
        productDetailsPageLink = type === ItemType.Product ? StringFormatter.format(navigation.productDetailsUrlFormat, exhibitingOrganisation.id, products[clickedSlideIndex].id) : null;
      }

    const getDtmTags = (packageId) => {
      let tags = {};
      if (packageId === Packages.gold) {
        tags = dtmTags.exhibitorDirectory.gold;
      } else {
        tags = dtmTags.exhibitorDirectory.silver;
      }
      return tags;
    };

    const getProductDtmAttributes = (product, exhibitorId) => {
        const attributes = {
            productId: product.id,
            exhibitorId,
        };
        attributes.isVideoAvailable = !!product.videoId;
        return JSON.stringify(attributes);
    }

    const getDtmAttributes = (type) => {
        return type === ItemType.Product
        ? getProductDtmAttributes(products[clickedSlideIndex], exhibitingOrganisation.id)
        : JSON.stringify({ documentType:documents[clickedSlideIndex].type, exhibitorId: exhibitingOrganisation.id })
    };

    const getMixpanelProps = (type) => {
        const mixpanelProps = type === ItemType.Document ? {
            documentName: Utils.removePdfFileNameExtension(documents[clickedSlideIndex].title),
            documentType: documents[clickedSlideIndex].type.toLowerCase(),
            downloadUrl: documents[clickedSlideIndex].url,
            type: mixpanelConstants.type.exhibitor
        } : {
            productId: products[clickedSlideIndex].id,
            productName: products[clickedSlideIndex].name,
            element: mixpanelConstants.element.overlayProductLink
        }
        return { ...mixpanelProps,
            exhibitorId: exhibitingOrganisation.id,
            exhibitorName: exhibitingOrganisation.name,
            packageName: Utils.getPackageName(exhibitingOrganisation.packageId),
            component: mixpanelConstants.component.exhibitorDirectory,
            subComponent: exhibitingOrganisation.isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard
        }
    }

    const style = {
      color: window.reactSettings.props.themes.brandPrimary
    };

    const titleCase = (title) => {
        return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
      }
      const onCloseClick = () => {
          closeModal();
          if (window.VidyardV4 && window.VidyardV4.players) {
              const player = window.VidyardV4.players.find(p => p.uuid === products[clickedSlideIndex].video?.partnerVideoUuid);
              const currentTime = player?._previousTime || 0;
              const totalDuration = player?.metadata?.length_in_seconds || 0;
              if (Math.floor(currentTime) >= 3) {
                  const mixpanelProps = getMixpanelProps(ItemType.Product);
                  delete mixpanelProps.viewedElement;
                  delete mixpanelProps.element;
                  trackMixpanelEvent(mixpanelConstants.eventName.productVideoPlayed, {
                      ...mixpanelProps,
                      videoId: products[clickedSlideIndex].video?.partnerVideoUuid,
                      playDuration: Math.floor(currentTime),
                      actionOnVideo: mixpanelConstants.propertyValue.actionOnVideo.closedOverlay,
                      totalVideoDuration: Math.floor(totalDuration),
                      percentageWatched: totalDuration > 0 ? Math.floor((currentTime / totalDuration) * 100) : 0
                  });
              }
          }

          if (window.VidyardV4 && window.VidyardV4.players) {
            window.VidyardV4.players = [];
          }
      }
    const renderModalClose = () => {
      return <button onClick={onCloseClick} className={Classes.modalCloseButton} style={style}>
          <FontAwesomeIcon icon={faTimes} />
          <span>{translations.modal.closeButtonText}</span>
      </button>
    }

    const disableDownload = () => {
        setDisplayError(true);
    }

  const isNavigating = useRef(false);

  useEffect(() => {
    const attachedPlayers = new Set();
    
    const attachPauseListener = (player) => {
      if (!player || attachedPlayers.has(player.uuid)) return;
      
      attachedPlayers.add(player.uuid);
      
      player.on('pause', () => {
        // Don't track if pause was triggered by navigation
        if (isNavigating.current) return;
        
        if (type === ItemType.Product) {
          const currentProduct = products.find(p => p?.video?.partnerVideoUuid === player.uuid);
          if (currentProduct) {
            const currentTime = player._previousTime || 0;
            const totalDuration = player.metadata?.length_in_seconds || 0;
            
            if (Math.floor(currentTime) >= 3) {
              const videoMixpanelProps = {
                ...getMixpanelProps(ItemType.Product),
                productName: currentProduct.name,
                productId: currentProduct.id,
                videoId: currentProduct.video.partnerVideoUuid,
                playDuration: Math.floor(currentTime),
                actionOnVideo: mixpanelConstants.propertyValue.actionOnVideo.videoPaused,
                totalVideoDuration: Math.floor(totalDuration),
                percentageWatched: totalDuration > 0 ? Math.floor((currentTime / totalDuration) * 100) : 0
              };
              delete videoMixpanelProps.viewedElement;
              delete videoMixpanelProps.element;
              trackMixpanelEvent(mixpanelConstants.eventName.productVideoPlayed, videoMixpanelProps);
            }
          }
        }
      });
    };
    
    window.onVidyardAPI = (vidyardEmbed) => {
      vidyardEmbed.api.addReadyListener((_, player) => {
        setIsVidyardReady(true);
        attachPauseListener(player);
      });
    };
    
  }, []);

    useEffect(() => {
      const isVidYardV4Defined = typeof (window.VidyardV4) != 'undefined';
      if (isVidYardV4Defined && isVidyardReady) {
        isNavigating.current = true;
        const players = window.VidyardV4.players;
        players.map(player => player.pause());
        const currentPlayer = players.filter(player => player.uuid === products[clickedSlideIndex].video?.partnerVideoUuid);
        if (currentPlayer.length > 0) {
          currentPlayer[0].play();
        }
        // Reset flag after a short delay to allow pause events to complete
        setTimeout(() => {
          isNavigating.current = false;
        }, 100);
      }
      setPreviousIndex(clickedSlideIndex);
    }, [clickedSlideIndex, isVidyardReady]);

    const trackMixpanelEventOnChevronClick = () => {
        // Track video progress when swiping away from a video
        if (type === ItemType.Product && previousIndex !== null) {
          const previousProduct = products[previousIndex];
          if (previousProduct?.video?.partnerVideoUuid && window.VidyardV4 && window.VidyardV4.players) {
            const videoPlayer = window.VidyardV4.players.find(p => p?.uuid === previousProduct.video.partnerVideoUuid);
            if (videoPlayer) {
              const currentTime = videoPlayer._previousTime || 0;
              const totalDuration = videoPlayer.metadata?.length_in_seconds || 0;
              
              // Only track if video was actually watched for at least 3 seconds
              if (Math.floor(currentTime) >= 3) {
                const videoMixpanelProps = {
                  ...getMixpanelProps(ItemType.Product),
                  productName: previousProduct.name,
                  productId: previousProduct.id,
                  videoId: previousProduct.video.partnerVideoUuid,
                  playDuration: Math.floor(currentTime),
                  actionOnVideo: mixpanelConstants.propertyValue.actionOnVideo.navigatedAway,
                  totalVideoDuration: Math.floor(totalDuration),
                  percentageWatched: totalDuration > 0 ? Math.floor((currentTime / totalDuration) * 100) : 0
                };
                delete videoMixpanelProps.viewedElement;
                delete videoMixpanelProps.element;
                trackMixpanelEvent(mixpanelConstants.eventName.productVideoPlayed, videoMixpanelProps);
              }
            }
          }
        }
        
        const eventName = type === ItemType.Product ? mixpanelConstants.eventName.productClicked : mixpanelConstants.eventName.documentClicked;

        const mixpanelProps = type === ItemType.Product ? {
            ...getMixpanelProps(ItemType.Product),
            productName: products[previousIndex].name,
            productId: products[previousIndex].id,
            element: mixpanelConstants.element.overlayChevron
        } : {
            ...getMixpanelProps(ItemType.Document),
            documentName: documents[previousIndex].title,
            element: mixpanelConstants.element.overlayChevron
        };

        delete mixpanelProps.downloadUrl;

        trackMixpanelEvent(eventName, mixpanelProps);
    }

    return (
            <Modal
                show={showModal}
                onHide={closeModal} animation={false}
                size="lg"
                style={{'--brand-color': window.reactSettings.props.themes.brandPrimary}}
            >
                <Modal.Header>
                    <p className={'current-slide'}>{clickedSlideIndex+1} {translations.modal.of} {type === ItemType.Product ? products.length : documents.length}</p>
                    {renderModalClose()}
                </Modal.Header>
                <Modal.Body>
                    <Swiper
                        initialSlide={clickedSlideIndex}
                        navigation={{ nextEl: `.${Classes.swiperButtonNext}`, prevEl: `.${Classes.swiperButtonPrev}`}}
                        loop={false}
                        modules={[Navigation]}
                        effect={'slide'}
                        speed={0}
                        onActiveIndexChange={(e) => {
                            setClickedSlideIndex(e.activeIndex);
                            setViewedDocuments((prevState) => prevState.add(e.activeIndex));
                            }}>
                        {
                           type === ItemType.Product
                               ? products.map((product,index)=>(
                                   <SwiperSlide key={product.id} slidesperview={1}>
                                       {
                                           !!product.video?.partnerVideoUuid
                                               ? <ProductVideoInOverLay
                                                   productIndex={clickedSlideIndex}
                                                   videoId={product.video?.partnerVideoUuid}
                                                   autoplay={index === clickedSlideIndex}
                                                   mixpanelProps={getMixpanelProps(ItemType.Product)}
                                               />
                                               : <ProductImageInOverLay
                                                   productIndex={clickedSlideIndex}
                                                   src={product.imageUrl}
                                                   imageSize={ImageTypes.productDetails}
                                                   translations={translations}
                                                   mixpanelProps={getMixpanelProps(ItemType.Product)}
                                               />
                                       }
                                   </SwiperSlide>
                               ))
                               : documents.map((document, index) => (
                                   <SwiperSlide key={index} slidesperview={1}>
                                    {viewedDocuments.has(index) ? <RenderPdf mixpanelProps={getMixpanelProps(ItemType.Document)} documentUrl={document.url} translations={translations} disableDownload={disableDownload} displayError={displayError} /> : null}
                                </SwiperSlide>
                            ))
                        }
                        <div className={`${Classes.swiperButtonPrev} hidden-xs`}
                             data-dtm={type === ItemType.Document ? getDtmTags(exhibitingOrganisation.packageId).modalDocumentCarouselChevron
                                 : getDtmTags(exhibitingOrganisation.packageId).modalProductCarouselChevron}
                             data-dtm-attributes={getDtmAttributes(type)}
                            onClick={trackMixpanelEventOnChevronClick}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </div>
                        <div className={`${Classes.swiperButtonNext} hidden-xs`}
                             data-dtm={type === ItemType.Document ? getDtmTags(exhibitingOrganisation.packageId).modalDocumentCarouselChevron
                                 : getDtmTags(exhibitingOrganisation.packageId).modalProductCarouselChevron}
                             data-dtm-attributes={getDtmAttributes(type)}
                            onClick={trackMixpanelEventOnChevronClick}
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </div>
                    </Swiper>
                </Modal.Body>
                <Modal.Footer>
                <div className={Classes.modalLinks}>
                        <div className={Classes.modalProductName}>{type === ItemType.Product ? products[clickedSlideIndex].name : Utils.removePdfFileNameExtension(titleCase(documents[clickedSlideIndex].title))}</div>
                       {(type === ItemType.Product && products[clickedSlideIndex].isNew) || (type === ItemType.Document && documents[clickedSlideIndex].type) ?
                       <div className={Classes.modalClipText}>{type === ItemType.Product ?
                        translations.modal.productCarouselClipText
                        : translations.modal.documentType[documents[clickedSlideIndex].type.toLowerCase()]}
                        </div>
                       : null }
                    </div>
                    <p className={Classes.modalProductDescription}>{type === ItemType.Product ? products[clickedSlideIndex].description : ''}</p>
                    <div className={Classes.modalLinks}>
                        {type === ItemType.Product ?
                            navigation.productDetailsUrlFormat &&
                                <a href={productDetailsPageLink}
                                    data-dtm={getDtmTags(exhibitingOrganisation.packageId).viewProductDetailsPage}
                                    data-dtm-attributes={getDtmAttributes(type)}
                                   onClick={() => trackMixpanelEvent(mixpanelConstants.eventName.productInteracted,
                                       getMixpanelProps(ItemType.Product))}>
                                    <Button
                                        className={classnames(Classes.primaryButton, Classes.centerBlock, Classes.marginLeft)}
                                        bsstyle={Classes.primary}>{translations.modal.productDetailsLinkText}
                                    </Button>
                                </a>
                        : <a
                            href={documents[clickedSlideIndex].url}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-dtm={getDtmTags(exhibitingOrganisation.packageId).downloadPdf}
                            data-dtm-attributes={getDtmAttributes(type)}
                            onClick={() => {
                                setTimeout(() => {
                                    // we need to set timeout in order to fix the event triggering twice because of target="_blank"
                                    trackMixpanelEvent(mixpanelConstants.eventName.documentDownloaded,
                                    getMixpanelProps(ItemType.Document));
                                }, 100);
                            }}
                            >
                                <Button
                                    className={classnames(Classes.primaryButton, Classes.centerBlock)}
                                    bsstyle={Classes.primary} disabled={displayError}
                                    style={displayError ? {backgroundColor: window.reactSettings.props.themes.brandPrimary,
                                        borderColor: window.reactSettings.props.themes.brandPrimary} : {}}
                                >
                                    {translations.modal.downloadPdf}
                                </Button>
                            </a>
                        }
                        <a href={exhibitorDetailsPageLink} data-dtm={getDtmTags(exhibitingOrganisation.packageId).viewExhibitorDetailsPage} data-dtm-attributes={getDtmAttributes(type)}>
                            <Button className={classnames(Classes.primaryButton, Classes.centerBlock)} bsstyle={Classes.primary}>{translations.modal.exhibitorDetailsLinkText}</Button>
                        </a>
                    </div>
                </Modal.Footer>
            </Modal>
    );
}

ExhibitorModal.propTypes = {
    showModal:PropTypes.bool.isRequired,
    closeModal:PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    documents: PropTypes.array.isRequired,
    clickedSlideIndex:PropTypes.number.isRequired,
    setClickedSlideIndex:PropTypes.func.isRequired,
    translations:PropTypes.object.isRequired,
    exhibitingOrganisation: PropTypes.object.isRequired,
    navigation: PropTypes.shape({
        exhibitorPublicDetailsUrlFormat: PropTypes.string.isRequired,
        productDetailsUrlFormat: PropTypes.string.isRequired
      }).isRequired,
    type: PropTypes.string,
}
export default ExhibitorModal;
